import { render, staticRenderFns } from "./AltaTecnicoPantalla.vue?vue&type=template&id=e5eaf38c&"
import script from "./AltaTecnicoPantalla.vue?vue&type=script&lang=ts&"
export * from "./AltaTecnicoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports